import { Box, Card, CardContent, ImageList, Stack, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { Repeat } from "lib/@components/repeat"
import Iconify from "minimals-template/components/Iconify"
import { RegimeImage } from "./regime-image"

export function RegimePreviewCard({ regime }) {
    const images = (regime?.images ?? regime?.$?.images ?? []).filter(Boolean).slice(0, 3)
    const name = regime?.label?.replaceAll("Live:", "").replaceAll("Ready:", "").trim() ?? ""
    const facilities = regime?.facilities ?? regime?.$?.facilities ?? []

    return (
        <Card>
            <CardContent sx={{ p: 2 }}>
                <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 2, fontSize: 16 }}>
                    Selected Regime
                </Typography>
                <If value={regime}>
                    <Box
                        sx={{
                            borderRadius: 1.5,
                            overflow: "hidden",
                            mb: 2,
                            height: 220,
                            bgcolor: images.length > 0 ? "background.neutral" : "#DEF2F4",
                        }}
                    >
                        <If value={images.length > 0}>
                            <ImageList
                                sx={{ width: 1, height: 220, m: 0 }}
                                cols={Math.min(3, images.length)}
                                rowHeight={220}
                            >
                                <Repeat list={images} item={<RegimeImage />} />
                            </ImageList>
                            <Else>
                                <Box
                                    sx={{
                                        height: 1,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: 48,
                                        opacity: 0.3,
                                        color: "text.secondary",
                                    }}
                                >
                                    <Iconify icon="pajamas:issue-type-maintenance" />
                                </Box>
                            </Else>
                        </If>
                    </Box>
                    <Stack spacing={1.25}>
                        <Typography variant="subtitle1" fontWeight={600}>
                            {name}
                        </Typography>
                        <If value={facilities.length > 0}>
                            <Typography variant="body2" color="text.primary">
                                {facilities.join(", ")}
                            </Typography>
                        </If>
                    </Stack>
                    <Else>
                        <Box
                            sx={{
                                height: 240,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: 1.5,
                                border: "2px dashed",
                                borderColor: "divider",
                                bgcolor: "background.neutral",
                            }}
                        >
                            <Typography variant="body2" color="text.secondary">
                                No Regime Selected
                            </Typography>
                        </Box>
                    </Else>
                </If>
            </CardContent>
        </Card>
    )
}
